import styled from 'styled-components';

import Button from '@material-ui/core/Button';

const StyledSubmitFeedbackButton = styled(Button)`
    border-color: #000000;
    border: '2px solid';
    font-family: Open Sans;
    font-weight: 600;
    margin-left: .1rem !important;
    margin-right: .8rem !important;
    color: white !important;
    background-color: black !important;
    padding: 7.5px 8px;
    line-height: 24.5px;
    size: 14px;
`;

export { StyledSubmitFeedbackButton };
